<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: "App",

  components: {
  },

  data: () => ({}),
};
</script>

<style>
  html { overflow-y: auto }
</style>
